"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

function deprecated(propType, message, defaultValue) {
  var deprecatedPropType = function deprecatedPropType(props, propName, componentName, location) {
    var propValue = props[propName];
    var output = typeof message === 'function' ? message(propName, propValue, props) : message;

    if (output && propValue !== defaultValue) {
      _devLogger.default.warn(output);
    }

    for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
      rest[_key - 4] = arguments[_key];
    }

    return propType.apply(void 0, [props, propName, componentName, location].concat(rest));
  };

  if (propType.__INTROSPECTION__) {
    deprecatedPropType.__INTROSPECTION__ = (0, _extends2.default)({}, propType.__INTROSPECTION__, {
      deprecated: true
    });
  }

  return deprecatedPropType;
}

var _default = deprecated;
exports.default = _default;
module.exports = exports.default;